module.exports = __webpack_public_path__ + "3a84e520e360119432e6bf48e14b8344.MP3";